import {
  GETINQUIRY_SUCCESS,
  GETINQUIRY_FAILED,
  RESET_GETINQUIRY,
  LOADING_GETINQUIRY,
  NETWORK_ERROR_GETINQUIRY,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetInquiry = () => {
  return { type: RESET_GETINQUIRY };
};

const getInquirys = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETINQUIRY });
  await partnerServices
    .post("inquiry", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(getInquirysuccess(res.data));
          break;
        case "success":
          dispatch(getInquirysuccess(res.data));
          break;
        default:
          dispatch(getInquiryFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETINQUIRY, payload: err });
    });
};
function getInquirysuccess(data) {
  return {
    type: GETINQUIRY_SUCCESS,
    payload: data,
  };
}
function getInquiryFailed(data) {
  return {
    type: GETINQUIRY_FAILED,
    payload: data,
  };
}

export { resetGetInquiry, getInquirys };
